import React, { useState } from "react";
import { Grid, IconButton, Tooltip } from "@material-ui/core";
import PieChartIcon from "@material-ui/icons/PieChart";
import clsx from "clsx";
import StatBoxSlim from "components/Stats/StatBoxSlim";
import PictreeReportPieDrawer from "components/Charts/PictreeReportPieDrawer";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: { display: "flex" },
  content: { flexGrow: 1, transition: theme.transitions.create("margin"), marginRight: 0 },
  contentShift: { marginRight: 500 },
}));

const ReportStatsSaitama = ({ data }) => (
  <ReportStatsSaitamaContent data={data} />
);

const ReportStatsSaitamaContent = ({ data }) => {
  const classes = useStyles();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const handleDrawerClose = () => setDrawerOpen(false);
  return (
    <div className={classes.root}>
      <main className={clsx(classes.content, { [classes.contentShift]: drawerOpen })}>
        <div style={{ marginBottom: 16 }}>
          <Tooltip title={drawerOpen ? "グラフを閉じる" : "グラフで表示"}>
            <IconButton
              onClick={() => setDrawerOpen(!drawerOpen)}
              style={{
                color: drawerOpen ? "#1976d2" : "#9e9e9e",
                border: "1px solid",
                borderColor: drawerOpen ? "#1976d2" : "#ccc",
                borderRadius: 4,
                padding: 6,
              }}
            >
              <PieChartIcon />
            </IconButton>
          </Tooltip>
        </div>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} md={2}><StatBoxSlim title="報告件数" value={data.totalReportCount ?? "-"} /></Grid>
          <Grid item xs={12} sm={6} md={2}><StatBoxSlim title="報告者数" value={data.totalReporterCount ?? "-"} /></Grid>
          {(data.reportStats || []).map((stat) => (
            <Grid item xs={12} sm={6} md={2} key={stat.tag_id || stat.tag_label}>
              <StatBoxSlim
                title={stat.tag_label}
                value={stat.total_count}
                valueExtra={data.tagAssignmentCount > 0 ? `全体比率: ${stat.percent.toFixed(2)}%` : "-"}
                tip={stat.tag_description}
              />
            </Grid>
          ))}
        </Grid>
      </main>
      <PictreeReportPieDrawer open={drawerOpen} onClose={handleDrawerClose} data={data.reportStats || []} />
    </div>
  );
};

export default ReportStatsSaitama;
